import * as yup from 'yup';
import { noSpaceAllowedInSchemaTest, themeObject } from '../../../../lib';

export const createDownloadJobDefaults = { fileType: '', query: '' };

export interface CreateDownloadJobFormInputs {
    fileType: string;
    query: string;
    password?: string;
}

export const createDownloadJobSchema = yup.object({
    fileType: yup.string().required(),
    query: noSpaceAllowedInSchemaTest(
        yup.string().required(),
        'Enter a valid query.'
    ),
    password: noSpaceAllowedInSchemaTest(
        yup.string().optional(),
        'Enter a valid password.'
    ),
});

export const createDownloadJobStyles = {
    container: {
        display: 'flex',
        flexDirection: 'column',
        '&::-webkit-scrollbar': { width: '8px' },
        '&::-webkit-scrollbar-track': {
            display: 'none',
        },
        '&::-webkit-scrollbar-thumb': {
            background: themeObject.palette.primary[500],
            borderRadius: '100px',
        },
        '& .MuiDialog-container': {
            backgroundColor: 'rgb(249,251,251)',
        },
    },
    containerWidth: {
        width: '100%',
        mt: 2,
    },
    autoCompleteStyles: {
        width: '100%',
        '& .MuiFormControl-root': {
            width: '100%',
        },
    },
    bodyContainer: {
        mt: 1,
        mx: '143.5px',
    },
    closeButtonStyles: {
        borderRadius: '48px',
        backgroundColor: themeObject.palette.grayScale[50],
    },
    buttonContainer: {
        display: 'flex',
        justifyContent: 'flex-end',
        mt: 2,
    },
    formControl: {
        paddingBottom: '16px',
    },
    errorContainer: {
        paddingTop: '2px',
    },
    queryLabel: {
        paddingBottom: '5px',
    },
    query: {
        border: `1px solid ${themeObject.palette.grayScale[300]}`,
        borderRadius: '2px',
        boxShadow: 'none',
    },
    queryError: {
        border: `1px solid ${themeObject.palette.tertiary.red[300]}`,
        borderRadius: '2px',
        boxShadow: 'none',
    },
    queryErrorHeight: '378px',
    passwordContainer: {
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
    },
    popperStyles: {
        width: '176px',
        height: '72px',
    },
};
